<template>
  <div class="progress">
    <div class="bar" :style="{'width': realProgress + '%'}"/>
  </div>
</template>

<script>
import anime from 'animejs'

export default {
  name: 'TaskProgress',
  props: {
    progress: {
      type: Number
    }
  },
  data () {
    return {
      realProgress: 0
    }
  },
  methods: {
    countUp () {
      // console.log(this.progress)
      anime({
        targets: this.$data,
        realProgress: this.progress,
        duration: 1000,
        delay: 200,
        round: 1,
        easing: 'easeInCubic'
      })
    }
  },
  mounted () {
    this.countUp()
  }
}
</script>

<style lang="scss" scoped>
@import '~@/stylesheets/color.scss';
.progress {
  width: 100%;
  height: .5rem;
  background: rgba($color_bleu_de_france, .1);
  .bar {
    transition: all .3s cubic-bezier(0.2, 0.8, 0.44, 0.05);
    background: #3D91F7;
    height: 100%;
    width: 0%;
  }
}
</style>
